var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Button, Card, Image, Text } from '@philips-internal/oswald-ui-components/lib/components';
import { func, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import moment from 'moment';
import './card-appointments-detail-location.css';
import locale from '../../../assets/images/global/location.svg';
import phone from '../../../assets/images/global/phone.svg';
import teleconsult from '../../../assets/images/global/camera-available.svg';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ButtonTheme, Placement, SelectionType, Size } from '@philips-internal/oswald-ui-constants';
import CardAppointmentLocationAPI from './card-appointment-detail-location-api';
import { SCHEDULE_OTHER_STATUS, SCHEDULE_STATUS } from '../../../util/card-util';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
let CardAppointmentsDetailLocation = class CardAppointmentsDetailLocation extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            data: {},
        };
    }
    static { this.propTypes = {
        dsEnderecoEstab: string,
        nmEstabelecimento: string,
        onEnterTeleconsultation: func
    }; }
    handleClickTeleconsultationButton() {
        const { onEnterTeleconsultation, nrSequencia, ieScheduleType } = this.props;
        if (onEnterTeleconsultation != null) {
            onEnterTeleconsultation(nrSequencia, ieScheduleType);
        }
    }
    renderLocationDetail() {
        const { ieTelemedicina, onEnterTeleconsultation, ieStatus, dtAgendamento } = this.props;
        if (ieTelemedicina === 'S' && ((ieStatus === SCHEDULE_STATUS.APPROVED)
            || (ieStatus === SCHEDULE_STATUS.CONFIRMED) || (ieStatus === SCHEDULE_OTHER_STATUS.EXECUTION))) {
            const actualDate = moment().startOf('day');
            const dateDiffInDays = moment(dtAgendamento).diff(actualDate, 'days');
            return (React.createElement("div", { className: 'teleconsultation-container' },
                React.createElement("div", { className: 'teleconsultation-tag' },
                    React.createElement("div", { className: 'card-appointments-detail-icon' },
                        React.createElement(Image, { src: teleconsult, className: 'icon-teleconsultation', alt: '' }),
                        React.createElement(Text, { bold: true, value: MessageService.translate('patient.teleconsultation') }))),
                onEnterTeleconsultation && dateDiffInDays === 0 ?
                    React.createElement("div", { className: 'teleconsultation-action' },
                        React.createElement(Button, { onClick: () => this.handleClickTeleconsultationButton(), value: MessageService.translate('appointment-card.btn-enter'), size: Size.SMALL, icon: '/static/assets/icons/camera-available.svg', iconPlacement: Placement.LEFT, theme: ButtonTheme.PRIMARY })) : React.createElement(React.Fragment, null)));
        }
        const { dsEnderecoEstab } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(Image, { src: locale, className: 'icon-addres', alt: '' }),
            React.createElement(Text, { bold: true, value: dsEnderecoEstab })));
    }
    renderPhone() {
        const { dsFoneEstab } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(Image, { src: phone, className: 'icon-addres', alt: '' }),
            React.createElement(Text, { bold: true, value: dsFoneEstab })));
    }
    render() {
        const { nmEstabelecimento } = this.props;
        return (React.createElement(Card, { className: 'card-appointments-detail-location', width: 12, selectionType: SelectionType.NONE, uuid: generateUUID() },
            React.createElement("div", { className: 'card-appointments-detail-location-content' },
                React.createElement("div", { className: 'card-appointments-detail-location-content-title' },
                    React.createElement(Text, { bold: true, value: MessageService.translate('new-appointment.establishment-location') })),
                React.createElement(Text, { value: nmEstabelecimento }),
                React.createElement("div", { className: 'card-appointments-detail-location-content-information' },
                    React.createElement("div", { className: 'card-appointments-detail-location-content-information-contact' }, this.renderPhone()),
                    React.createElement("div", { className: 'card-appointments-detail-location-content-information-location' }, this.renderLocationDetail())))));
    }
};
CardAppointmentsDetailLocation = __decorate([
    AwesomeComponent({ api: CardAppointmentLocationAPI, type: ComponentType.DATA_DISPLAY })
], CardAppointmentsDetailLocation);
export default CardAppointmentsDetailLocation;
//# sourceMappingURL=card-appointments-detail-location.js.map